import classnames from "classnames/bind"

const getCxFromStyles = (styles) => {
  const cx = classnames.bind(styles)

  return cx
}

export default getCxFromStyles